module.exports = __webpack_public_path__ + "img/discover.368f7942.jpg";